import { useTranslation } from 'react-i18next';
import RulesBlock from './RulesBlock'

export default function Body() {
    const { t } = useTranslation()
    return(
        <>
            <main>
                <div className="xbox__body rules">
                    <div className="xbox__div-1 rules__table">
                        <RulesBlock title={t('rules.main.title')} categoryIndex={1} items=
                            {[
                                t('rules.main.text1'), 
                                t('rules.main.text2'), 
                                t('rules.main.text3'),
                                t('rules.main.text4'), 
                                t('rules.main.text5'),
                                t('rules.main.text7'), 
                                t('rules.main.text8'), 
                                t('rules.main.text9')
                            ]}
                        />
                        <RulesBlock title={t('rules.gameplay.title')} categoryIndex={2} items=
                            {[
                                t('rules.gameplay.text1'), 
                                t('rules.gameplay.text2'), 
                                t('rules.gameplay.text3'),
                                t('rules.gameplay.text4')
                            ]}
                        />
                        <RulesBlock title={t('rules.teams.title')} categoryIndex={3} items=
                            {[
                                t('rules.teams.text1'), 
                                t('rules.teams.text2'), 
                                t('rules.teams.text3'), 
                                t('rules.teams.text4')
                            ]}
                        />
                        <RulesBlock title={t('rules.chat.title')} items={[t('rules.chat.text1'),t('rules.chat.text2'),t('rules.chat.text3'),t('rules.chat.text4'),t('rules.chat.text5')]} categoryIndex={4}/>
                        <RulesBlock title={t('rules.check.title')} items={[t('rules.check.text1'),t('rules.check.text2'),t('rules.check.text3'),t('rules.check.text4')]} categoryIndex={5}/>
                        <RulesBlock title={t('rules.banReasons.title')} categoryIndex={6} items=
                            {[
                                t('rules.banReasons.text1'),
                                t('rules.banReasons.text1a'),
                                t('rules.banReasons.text2'),
                                t('rules.banReasons.text3'),
                                t('rules.banReasons.text4'),
                                t('rules.banReasons.text5'),
                                t('rules.banReasons.text6')
                            ]}/>
                        <RulesBlock title={t('rules.unban.title')} items={[t('rules.unban.text1')]} url={'https://vk.com/rusty_life_moder'}/>
                    </div>
                </div>
            </main>
        </>
    )
}